var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"projects-button",attrs:{"to":_vm.to}},[_vm._v("\n  "+_vm._s(_vm.title)+" "),_c('span',{staticClass:"projects-button__arrow"},[_vm._v(" ← ")])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c373368","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/containers/Details/ProjectsButton.vue
// module id = null
// module chunks = 